import React, { useRef } from 'react'
import { Button } from '@chakra-ui/react'
import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogHeader,
    AlertDialogFooter,
    AlertDialogOverlay,
    AlertDialogContent,
} from '@chakra-ui/react'

interface Props {
    isOpen: boolean
    onClose: () => void
    onDiscard: () => void
}

export default function AlertChanges({ isOpen, onClose, onDiscard }: Props) {
    const cancelRef = useRef(null)

    return (
        <AlertDialog
            isOpen={isOpen}
            leastDestructiveRef={cancelRef}
            onClose={onClose}
            closeOnEsc={false}
            size="xl"
        >
            <AlertDialogOverlay />
            <AlertDialogContent>
                <AlertDialogHeader
                    fontSize="md"
                    borderBottomWidth={4}
                    borderBottomColor="danger.500"
                >
                    Discard changes?
                </AlertDialogHeader>
                <AlertDialogBody pt={6} pb={2} fontSize="sm" textAlign="center">
                    You have unsaved changes. Are you sure you want to discard
                    them?
                </AlertDialogBody>
                <AlertDialogFooter
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Button ref={cancelRef} size="sm" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button
                        colorScheme="danger"
                        size="sm"
                        onClick={() => {
                            onDiscard()
                            onClose()
                        }}
                    >
                        Discard
                    </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}
